import createItemsDuck from '@esentai/core/ducks/items';

import api from '../api';
import { getItemsRoot } from '../utils';

export default createItemsDuck('store_bonus_history', {
  api,
  getRoot: getItemsRoot,
});
